export const getObjectFromCollectionSnapshot = (snapshot) =>
    snapshot.docs.reduce((acc, document) => {
        acc[document.id] = document.data();
        return acc;
    }, {});
